<script setup lang="ts">
import { h, useAttrs, useSlots } from "vue";
import { useRouterLink, type RouterProps } from "../../composables/router";

interface Props extends RouterProps {
	disabled?: boolean;
	listClass?: string;
}

defineOptions({ inheritAttrs: false });

const props = defineProps<Props>();

const { renderLink, getTag } = useRouterLink(props);

const slots = useSlots();
const attrs = useAttrs();
function render(props: any) {
	const node = h(getTag("div"), props, slots.default?.());

	return renderLink(node);
}
</script>

<template>
	<li
		:class="{
			'menu-disabled': disabled,
			[listClass || '']: true,
		}"
	>
		<component :is="render" class="active:bg-active!" v-bind="attrs" />
	</li>
</template>
